import { useContext, useEffect } from 'react';

import { MessagingContext } from '@sorare/wallet-shared';
import type { RecoverKey } from '@sorare/wallet-shared';

import { useAuthContext } from '#src/contexts/auth/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useWalletContext } from '#src/contexts/wallet/index.ts';
import { formatUpdateUserErrors } from '#src/lib/http.ts';

export const useRecoverKey = () => {
  const { registerHandler } = useContext(MessagingContext)!;
  const { updateUser } = useAuthContext();
  const { handleWalletSuccessullyRecovered } = useWalletContext();
  const { refetch, currentUser } = useCurrentUserContext();

  useEffect(
    () =>
      registerHandler<RecoverKey>(
        'recoverKey',
        async ({ passwordHash, userPrivateKey }) => {
          if (!currentUser) throw new Error('Missing current user');
          const { errors } = await updateUser({
            currentPasswordHash: passwordHash,
            sorarePrivateKey: userPrivateKey,
          });

          if (errors) return { error: formatUpdateUserErrors(errors) };

          await handleWalletSuccessullyRecovered();
          return {};
        }
      ),
    [
      handleWalletSuccessullyRecovered,
      registerHandler,
      updateUser,
      refetch,
      currentUser,
    ]
  );
};
